import React from 'react';

const Heading_left_bor = (props) => {
    return (
        <div className='Heading_left_bor'>
            <h2>{props.Heading_text}<span>{props.Heading_span}</span></h2>
        </div>
    )
}

export default Heading_left_bor;